import { createSlice } from '@reduxjs/toolkit';

interface PauseStateIF {
    isPaused: boolean;
    isPausedVisible: boolean;
    isPausedAnimating: boolean;
}

const initialState: PauseStateIF = {
    isPaused: false,
    isPausedVisible: false,
    isPausedAnimating: false,
};

const pauseSlice = createSlice({
    name: 'pause',
    initialState,
    reducers: {
        startPause: (state) => {
            state.isPaused = true;
            state.isPausedVisible = true;
            state.isPausedAnimating = true;
        },
        endPause: (state) => {
            state.isPaused = false;
            state.isPausedVisible = false;
        },
        resetPauseAnimation: (state) => {
            state.isPausedAnimating = false;
        },
    },
});

export const { startPause, endPause, resetPauseAnimation } = pauseSlice.actions;

pauseSlice.reducerPath = 'pause';

export { pauseSlice };
